var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("p", {
    staticClass: "custom-p-label right-read",
    domProps: { innerHTML: _vm._s(_vm.transform(this.str)) },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }